import React, { Component } from 'react';

import moment from 'moment';

import { card, alertCircleOutline } from 'ionicons/icons';
import {
  withIonLifeCycle,
  IonContent,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonButton,
  IonIcon,
  IonLabel,
  IonItem,
  IonText,
  IonGrid,
  IonRow,
  IonCol,
} from '@ionic/react';

import ReservationsService from '../../services/reservations';
import HeaderButtons from '../../components/HeaderButtons';

import '../../theme/container.css';
import './payment.css';

class ReservationPaymentPage extends Component {
  constructor(props) {
    super(props);

    this.countdownInterval = undefined;

    this.state = {
      reservationId: this.props.match.params.id,
      payment: undefined,
      remainingSeconds: 0,
      loaded: false,
      paying: false,
    };
  }

  async ionViewWillEnter() {
    await this.setState({ reservationId: this.props.match.params.id, payment: undefined, loaded: false });

    try {
      if (this.props.loader?.current) this.props.loader.current.show();

      const { data: response } = await ReservationsService.paymentShow(this.state.reservationId);
      const payment = response?.data || response;

      await this.setState({ payment });
      this.startCountdown(payment.expires_at || payment.payment_expires_at);
    } catch (error) {
      // 403, 404 o 409: la prenotazione non può più essere pagata
      if (error.response?.status !== 401) console.error(error);
    } finally {
      this.setState({ loaded: true });
      if (this.props.loader?.current) this.props.loader.current.dismiss();
    }
  }

  ionViewWillLeave() {
    this.stopCountdown();
  }

  // Avvia il conto alla rovescia fino alla scadenza del pagamento
  startCountdown(expiresAt) {
    this.stopCountdown();

    const updateRemainingSeconds = () => {
      const remainingSeconds = Math.max(0, moment(expiresAt).diff(moment(), 'seconds'));
      this.setState({ remainingSeconds });

      if (remainingSeconds === 0) this.stopCountdown();
    };

    updateRemainingSeconds();
    this.countdownInterval = setInterval(updateRemainingSeconds, 1000);
  }

  stopCountdown() {
    if (this.countdownInterval) clearInterval(this.countdownInterval);
    this.countdownInterval = undefined;
  }

  // Crea l'ordine PayPal e porta l'utente alla pagina di approvazione
  async pay() {
    this.setState({ paying: true });

    try {
      const { data: response } = await ReservationsService.paymentCreate(this.state.reservationId);
      const { approve_url: approveUrl } = response?.data || response;

      window.location.href = approveUrl;
    } catch (error) {
      console.error(error);
      if (this.props.toast?.current) {
        this.props.toast.current.add({
          message: error.response?.data?.message || 'Impossibile avviare il pagamento. Riprova.',
          color: 'danger',
        });
      }
      this.setState({ paying: false });
    }
  }

  formatRemainingTime(remainingSeconds) {
    const minutes = Math.floor(remainingSeconds / 60);
    const seconds = remainingSeconds % 60;

    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  renderUnavailable() {
    return (
      <div className="ion-text-center ion-padding-vertical">
        <IonIcon style={{ fontSize: '80px' }} color="danger" icon={alertCircleOutline}></IonIcon>
        <h1>Tempo scaduto</h1>
        <p>Il tempo per il pagamento è terminato oppure la prenotazione non è più disponibile.</p>
        <IonButton color="light" expand="block" onClick={() => this.props.history.push('/app/services')}>
          Torna al calendario
        </IonButton>
      </div>
    );
  }

  renderSummary() {
    const { payment, remainingSeconds, paying } = this.state;
    const reservation = payment.reservation || payment;
    const serviceName = reservation.service?.name || reservation.shop_service?.name || payment.service_name;
    const startDay = reservation.start_day;

    return (
      <>
        <IonItem lines="none">
          <IonLabel>
            <h4 className="ion-text-uppercase">Servizio:</h4>
            <p>{serviceName}</p>
          </IonLabel>
        </IonItem>

        {!!startDay && (
          <>
            <IonItem lines="none">
              <IonLabel>
                <h4 className="ion-text-uppercase">Giorno:</h4>
                <p>{moment(startDay).format('dddd | DD MMMM YYYY')}</p>
              </IonLabel>
            </IonItem>

            <IonItem lines="none">
              <IonLabel>
                <h4 className="ion-text-uppercase">Ora:</h4>
                <p>{moment(startDay).format('HH:mm')}</p>
              </IonLabel>
            </IonItem>
          </>
        )}

        <IonItem lines="none">
          <IonLabel>
            <h4 className="ion-text-uppercase">Acconto da pagare:</h4>
            <p>
              <b>€ {Number(payment.amount).toFixed(2)}</b>
            </p>
          </IonLabel>
        </IonItem>

        <IonItem lines="none">
          <IonText color="warning">
            <p>
              La prenotazione viene mantenuta ancora per <b>{this.formatRemainingTime(remainingSeconds)}</b>. Allo
              scadere del tempo verrà annullata.
            </p>
          </IonText>
        </IonItem>

        <IonGrid>
          <IonRow>
            <IonCol size="12">
              <IonButton
                expand="block"
                color="success"
                disabled={paying}
                onClick={() => this.pay()}
                className="ion-margin-horizontal"
              >
                <IonIcon icon={card} />
                &nbsp;
                <IonLabel>Paga con PayPal</IonLabel>
              </IonButton>
            </IonCol>
          </IonRow>
        </IonGrid>
      </>
    );
  }

  render() {
    const { payment, remainingSeconds, loaded } = this.state;
    const canPay = !!payment && remainingSeconds > 0;

    return (
      <>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton defaultHref="/app/reservations" />
            </IonButtons>
            <HeaderButtons {...this.props} />
            <IonTitle>Pagamento acconto</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent className="ion-padding">
          {loaded && (canPay ? this.renderSummary() : this.renderUnavailable())}
        </IonContent>
      </>
    );
  }
}

export default withIonLifeCycle(ReservationPaymentPage);
